import LeftArrow from './LeftArrow';
import RightArrow from './RightArrow';
import {useSearchParams} from 'react-router-dom';
import {useEffect} from 'react';

const BLOCK_SIZE = 5;
const PAGE_SIZE = 8;

export default function Pagination({ totalLength }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const maxPage = Math.ceil(totalLength / PAGE_SIZE);
  const maxBlock = Math.ceil(maxPage / BLOCK_SIZE);

  useEffect(() => {
    const curPage = searchParams.get('page');
    const curBlock = searchParams.get('block');

    if (!curPage || !curBlock) {
      const newParams = new URLSearchParams(searchParams);

      if (!curPage) {
        newParams.set('page', '1');
      }
      if (!curBlock) {
        newParams.set('block', '1');
      }

      setSearchParams(newParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const getPageNumbers = () => {
    const pageNumbers = [];
    const curBlock = +searchParams.get('block') - 1

    for (let i = curBlock * BLOCK_SIZE; i < (curBlock + 1) * BLOCK_SIZE && i < maxPage; i++) {
      pageNumbers.push(i)
    }

    return pageNumbers;
  }

  // const clickBackArrow = () => {
  //   if (curBlock > 0) {
  //     setCurBlock(prev => prev - 1);
  //   }
  // }
  //
  // const clickForwardArrow = () => {
  //   if (maxBlock - 1 === curBlock) {
  //     setCurBlock(prev => prev + 1);
  //   }
  // }

  const clickNumber = (number) => {
    setSearchParams(prev => {
      prev.set('page', (number + 1) + '');
      return prev;
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  const isEnableLeftArrow = () => {
    return (+searchParams.get('block') || 1) !== 1;
  }

  const isEnableRightArrow = () => {
    return maxBlock > (+searchParams.get('block') || 1);
  }

  // todo 일단 pagination 막아둠

  return (
    <div className='flex justify-center items-center gap-x-[25px] mt-[100px]'>
      <LeftArrow
        opacity={isEnableLeftArrow() ? 1 : 0.3}
        cursor={isEnableLeftArrow() ? 'pointer' : null}
        stroke='#393939'
        // onClick={clickBackArrow}
      />
      <div className='flex gap-x-[10px]'>
        {
          getPageNumbers().map(item => (
            <div key={item}
                 className={
                   ((item + 1) === +searchParams.get('page') ? 'bg-[#0084DB] text-white ' : 'text-label-100 ') +
                   'flex justify-center items-center ' +
                   'w-[34px] h-[34px] rounded-[100px] ' +
                   'text-heading3 ' +
                   'cursor-pointer'
                 }
                 onClick={() => clickNumber(item)}
            >
              {item + 1}
            </div>
          ))
        }
      </div>
      <RightArrow
        opacity={isEnableRightArrow() ? 1 : 0.3}
        cursor={isEnableRightArrow() ? 'pointer' : null}
        // onClick={clickForwardArrow}
      />
    </div>
  );
}